import { TimeoutProps } from 'react-transition-group/Transition';
import { ReactElement, CSSProperties } from 'react';

export type RenderItem = (
  index: number,
  props?: {
    timeoutProps?: Partial<TimeoutProps<undefined>>;
    itemKey?: (index: number) => number | string;
    index2d?: { rowIndex: number; columnIndex: number };
    style?: CSSProperties;
  },
) => ReactElement | null;
